<script>
import CoreComponent from '../../../../../../../dow-platform/ui.frontend/src/dow-platform/components/core/CoreComponent.vue'

export default {
  extends: CoreComponent,

  mounted() {
    if (!this.cmpEl) return

    this.cmpEl.querySelectorAll('a').forEach(element =>
      element.addEventListener(
        'click',
        function () {
          if (!this.$store || !this.cmpEl) return
          this.$store.dispatch('trackLink', {
            name: (element.innerText && element.innerText.trim()) || 'undefined',
            position: this.cmpEl.id || 'unknown'
          })
        }.bind(this)
      )
    )

    var button = this.cmpEl.querySelector('a')
    if (!button) return

    var title = this.cmpEl.querySelector("div.corporate-title")?.innerText
    if (!button.ariaLabel) {
      var btnText = (button.textContent || button.innerText || '').trim()
      button.ariaLabel = title ? btnText + ': ' + title : btnText
    }
  }
}
</script>

<style lang="scss">
@import './flexband.scss';
</style>